import type { HottrMessageRow } from '@/lib/database.types';

export interface HottrMessage {
  id: string;
  conversationId: string;
  senderId: string;
  content: string;
  readAt: string | null;
  createdAt: string;
}

export const mapMessageRow = (r: HottrMessageRow): HottrMessage => ({
  id: r.id,
  conversationId: r.conversation_id,
  senderId: r.sender_id,
  content: r.content,
  readAt: r.read_at,
  createdAt: r.created_at,
});

export type ValidationResult =
  | { ok: true; content: string }
  | { ok: false; error: string };

/**
 * Trim + length check for outgoing messages. Pure — composer/UI calls it
 * before any DB round-trip so the user gets immediate feedback.
 */
export const validateMessageContent = (raw: string): ValidationResult => {
  const trimmed = raw.trim();
  if (!trimmed) return { ok: false, error: 'Message cannot be empty.' };
  if (trimmed.length > 2000) return { ok: false, error: 'Message too long.' };
  return { ok: true, content: trimmed };
};
